import clsx from "clsx"
import PropTypes from "prop-types"
import { IoMdAdd } from "react-icons/io"

const NewActionButton = ({
  title,
  icon,
  haveIcon = false,
  action,
  className,
  actionType = "create",
  contained = true,
}) => {
  return (
    <button
      className={clsx(
        "h-full uppercase p-3 rounded-lg font-medium text-sm flex items-center",
        className && className,
        actionType === "create" &&
          contained &&
          "hover:bg-[#10737B] bg-brand-secondary",
        actionType === "create" && !contained && "text-brand-secondary",
        actionType === "delete" && contained && "bg-[red] hover:opacity-80",
        actionType === "delete" && !contained && "text-[red]",
        contained && "button-box-shadow text-[white]",
      )}
      onClick={action}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          action()
        }
      }}
    >
      {haveIcon && (!icon ? <IoMdAdd size={18} className="mr-2" /> : icon)}
      {title ? title : "New"}
    </button>
  )
}

NewActionButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
  haveIcon: PropTypes.bool,
  action: PropTypes.func,
  className: PropTypes.string,
  actionType: PropTypes.string,
  contained: PropTypes.bool,
}
export default NewActionButton
